<template>
  <div>
    <div class="form-row">
      <div class="form-field">
        <label for="kpp-type-select">Выберите договор:</label>
        <select id="kpp-type-select" v-model="newAgreement.CONTRACT" @change="services = documents[$event.target.value].SERVICES_OBJECT">
          <option
            v-for="(document, key) in documents"
            :value="document.ID"
            :key="key"
          >
            {{ document.NAME }}
          </option>
        </select>
      </div>

      <template v-for="(aface, kkey) in newAgreement.DATA.FACES" >
        <div class="form-field">
          <label>
            Лицо:
            <select v-model="aface.FACE">
              <option v-for="(face, key) in faces" :key="key" :value="face.ID" >{{face.USER_NAME}}</option>
            </select>
          </label>
        </div>
        <div class="form-field">
          <label>
            Выбрать как плательщика:
            <input
              type="checkbox"
              v-model="aface.MAIN"
            />
          </label>
        </div>
      </template>

      <div class="form-field">
        <button @click="addFace">Добавить лицо</button>
      </div>

      <template v-if="newAgreement.CONTRACT && services">
        <template v-for="(service, kkey) in services" >
          <div class="form-field">
            Услуга: <b style="cursor: pointer;" v-on:click="open_services[kkey]=true">{{service.NAME}}</b>
          </div>
          <template  v-show="open_services[kkey]==true">
            <div class="form-field">
              <label>
                Тип скидки:
                <select v-model="service.TYPE_OF_DISCOUNT">
                  <option value="Скидка">Скидка</option>
                  <option value="Персональная цена">Персональная цена</option>
                </select>
              </label>
            </div>
            <div class="form-field" v-show="service.TYPE_OF_DISCOUNT=='Скидка'">
              <label>
                Скидка:
                <input
                  type="text"
                  v-model="service.DISCOUNT_PERCENT"
                />
              </label>
            </div>
            <div class="form-field" v-show="service.TYPE_OF_DISCOUNT=='Персональная цена'">
              <label>
                Персональная цена:
                <input
                  type="text"
                  v-model="service.DISCOUNT_PRICE"
                />
              </label>
            </div>
            <div class="form-field">
              <label>
                Количество месяцев рассрочки:
                <input
                  type="text"
                  v-model="service.PRE_MONTH"
                />
              </label>
            </div>
            <div class="form-field">
              <label>
                Сумма предоплаты рассрочки:
                <input
                  type="text"
                  v-model="service.PRE_SUM"
                />
              </label>
            </div>
          </template>
        </template>
      </template>

      <div class="form-field">
        <label>
          Номер договора:
          <input
            type="text"
            v-model="newAgreement.DOCUMENT_NUMBER"
          />
        </label>
      </div>

      <div class="form-field">
        <label>
          Дата договора:
          <input
            type="text"
            v-model="newAgreement.DOCUMENT_DATE"
          />
        </label>
      </div>
      <div class="form-field">
        <button @click="sendUserData">Добавить</button>
      </div>
    </div>
    <div class="form-row" v-if="info">{{ info }}</div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "addAgreement",
  props: ["plot"],
  data() {
    return {
      url: config.backend_url,
      info: null,
      newAgreement: {
        DATA: {
          FACES: [
            {}
          ]
        }
      },
      idPlot: this.plot,
      features: [],
      faces: [],
      services: [],
      open_services: {},
      documents: [],
      contracts: []
    };
  },
  computed: {},
  methods: {
    sendUserData: function() {
      let self = this;
      this.newAgreement.PLOT = this.idPlot;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "documents/add-plot-agreement/",
          data: this.newAgreement,
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (data) {
            self.info = "Договор добавлен";
            self.$emit("document-add");
          }
        });
    },
    getPlotData: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "plots/get-plot-documents/",
          data: { ID: this.idPlot },
          method: "POST"
        })
        .then(response => {
          let data = response.data;
          if (!data.error) {
            console.log(data);
            this.documents = data;
          }
        });
    },
    getPlotFaces: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "plots/get-plot-faces/",
          data: { ID: this.idPlot },
          method: "POST"
        })
        .then(response => {
          let data = response.data;
          console.log(data);
          if (!data.error) this.faces = data;
        });
    },
    getContracts: function() {
      let data = {
        url: this.url + "agreementtypelist/get/",
        data: {},
        method: "POST"
      };
      this.$store.dispatch("query/sendRequest", data).then(response => {
        let data = response.data;
        if (!data.error) {
          this.contracts = data;
        }
      });
    },
    addFace: function(){
      this.newAgreement.DATA.FACES.push({});
    }
  },
  created() {
    this.getPlotData();
    this.getContracts();
    this.getPlotFaces();
  }
};
</script>
